import config from '@/core/config/config';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { replaceLocationBasedTerms } from '@/utils/replaceLocationBasedTerms';
import { InformationCircleLg } from '@prenuvo/halo-icon';
import { Container, Icon, Typography } from '@prenuvo/halo-web';
import { useShallow } from 'zustand/react/shallow';

export const RescheduleCancellationNotice = () => {
  const { locationId } = usePrenuvoStore(
    useShallow((state) => ({
      locationId: state.scan.locationId,
    })),
  );

  return (
    <Container className="sm:flex-column mb-6 mt-4 flex gap-4 border border-blue-500 p-4 md:flex-row md:items-center">
      <div>
        <Icon
          className="fill-current text-blue-700"
          size="md"
          source={InformationCircleLg}
          role="img"
          aria-label="information icon"
        />
      </div>
      <div>
        <Typography variant="paragraph-sm" as="p" className="leading-6">
          {replaceLocationBasedTerms('Appointments', locationId)} may be rescheduled or cancelled up
          to 3 business days (Mon-Fri less holidays) before the scheduled{' '}
          {replaceLocationBasedTerms('appointment', locationId)}. After this time, deposits are
          non-refundable and non-transferrable.
        </Typography>
        <Typography variant="paragraph-sm" as="p" className="leading-6">
          Please{' '}
          <Typography variant="link">
            <a href={`${config.BASE_URL}/contact`} target="_blank">
              contact us
            </a>
          </Typography>{' '}
          if you need to make changes to your {replaceLocationBasedTerms('appointment', locationId)}
          .
        </Typography>
      </div>
    </Container>
  );
};
